<template>
  <div>
    <div class="d-flex">
      <b-form-radio v-model="pref" value="true" class="mr-3">Yes</b-form-radio>
      <b-form-radio v-model="pref" value="false">No</b-form-radio>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'value', 'url', 'disabled'],
  data() {
    return {
      pref: this.value === 'true',
      ignorePrefChange: false
    }
  },
  watch: {
    pref(val) {
      if (!this.url || !this.name) return;

      if (this.ignorePrefChange) {
        this.ignorePrefChange = false;
        return;
      }

      const formData = new FormData();
      formData.append(this.name, this.pref);
      this.$http.patch(this.url, formData).then(fulfilled => {
        location.reload()
      }, rejected => {
        this.ignorePrefChange = true;
        this.pref = !this.pref;
        this.showErrorToast(this.getErrorMessages(rejected.body, true));
      })
    }
  }
}
</script>